import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import RandomContent from '../Components/RandomContent';
import { GetQuestionsBySubject, GetAllInterviewSubjects } from '../services/apiservice';
import InterviewQuestionItem from '../Components/InterviewQuestionItem';
import Loader from '../Components/Loader';

const InterviewQuestionsAnswers = () => {
  const { subject } = useParams();
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageNumber] = useState(1);
  const [pageSize] = useState(50);
  const [subjects, setSubjects] = useState([]);
  const navigate = useNavigate();

   const fetchSubjects = async () => {
      try {
        const subjectList = await GetAllInterviewSubjects();
        const jsonSubjectList = JSON.parse(subjectList);
        setSubjects(jsonSubjectList);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching interview subjects:', error);
        setLoading(false);
      }
    }

  const fetchQuestions = async () => {
    try {
      setLoading(true);
      const questionList = await GetQuestionsBySubject(subject, pageNumber, pageSize);
      //const jsonQuestionList = JSON.parse(questionList);

      const jsonQuestionList = JSON.parse(questionList);
      setQuestions(jsonQuestionList.question || []);
    } catch (error) {
      console.error('Error fetching interview questions:', error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchSubjects();

    if (subject) {
      fetchQuestions();
    }
  }, [subject, pageNumber]);

  const handleSubjectClick = (subjectSlug) => {
    navigate(`/questions-answers/${subjectSlug}`);
  }

  return (
    <div>


      <Header />

      <RandomContent />


      <div className="blog-area ptb-20">
        <div className="container-block-fluid" style={{ maxWidth: '80%', margin: '0 auto' }}>
          <div className="row" style={{ justifyContent: 'center' }}>
            {loading ? (
              <Loader />
            ) : subjects?.length === 0 ? (
              <div className="col-12 text-center">
                <p>No interview subjects available yet.</p>
              </div>
            ) : (
              subjects?.map((subject) => (

                <div key={subject.id} className="full-col col-lg-2 col-sm-6">
                  <div
                    className="single-counter subject-card"
                    data-aos="fade-up"
                    data-aos-duration="1200"
                    onClick={() => handleSubjectClick(subject.paramlink)}
                  >
                    <h5>
                      <span class="odometer1" data-count="540">{subject.name}</span>
                    </h5>
                    <p>Questions ({subject.questions || 0})</p>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>

      <div className="interview-area ptb-20">
        <div className="container-block-fluid">
          <div className="row justify-content-center">
            <div className="full-col col-lg-12 col-md-12">
              {loading ? (
                <Loader />
              ) : questions?.length === 0 ? (
                <div className="text-center">
                  <p>No interview questions available for this subject yet.</p>
                </div>
              ) : (
                <div className="container-fluid">
                  <div className="row justify-content-center">
                    <div className="col-12 col-sm-12 col-md-11 col-lg-10 col-xl-8">
                      <div className="full-col">
                        <div
                          className="faq-accordion"
                          data-aos="fade-up"
                          data-aos-duration="1600"
                        >
                          <ul className="accordion">
                            {questions?.map((question, index) => (
                              <InterviewQuestionItem
                                key={question.id}
                                question={question}
                                index={index + 1}
                              />
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default InterviewQuestionsAnswers;